import { FormStatus } from '@/src/app/shared/enums/form-status.enum';
import { Component, Input } from '@angular/core';

import { TreatmentStatusIndicatorComponent } from '@shared/components/treatment-status-indicator/treatment-status-indicator.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-compact-patient-header',
  templateUrl: './compact-patient-header.component.html',
  imports: [TreatmentStatusIndicatorComponent, TranslateModule]
})
export class CompactPatientHeaderComponent {
  @Input() rowNumber = 0;
  @Input() status: FormStatus | null = null;
}
